import type { LatLng } from '@/components/shipment/form/utils/build-routing-coordinates';
import type { RoutingStrategy } from '@/components/shipment/form/utils/shipment-form-routing';

export type ShipmentFormStopFieldKey =
  | 'location'
  | 'radius'
  | 'plannedDeparture'
  | 'plannedArrival';

export type ShipmentFormMapContext = {
  routingStrategy?: RoutingStrategy;
  /** First assigned tracker — shared-route origin only (not the sole map marker). */
  primaryTrackerPosition?: LatLng | null;
  /** All convoy tracker positions for form map markers. */
  trackerPositions?: LatLng[];
  routesHydrationReady?: boolean;
  isFormHydrated?: boolean;
  trackerLoading?: boolean;
  isMapBootstrapMode?: boolean;
};

export type ShipmentFormEditContext = ShipmentFormMapContext & {
  mode: 'edit';
  getStopDisabledFields?: (
    index: number,
    total: number,
  ) => Partial<Record<ShipmentFormStopFieldKey, boolean>>;
  getStopLockReason?: (index: number, total: number) => string | undefined;
  getStopLockBadgeLabel?: (index: number, total: number) => string | undefined;
  hideWaypointControls?: boolean;
};

export type ShipmentFormCreateContext = ShipmentFormMapContext & {
  mode: 'create';
};

export type ShipmentFormPageContext =
  | ShipmentFormEditContext
  | ShipmentFormCreateContext;

export function isEditPageContext(
  ctx: ShipmentFormPageContext | undefined,
): ctx is ShipmentFormEditContext {
  return ctx?.mode === 'edit';
}
